import React from 'react';
import PropTypes from 'prop-types';
import WizardLayout from './WizardLayout';
import AuthWizardProvider from 'providers/AuthWizardProvider';

const Wizard = ({ variant, validation, progressBar, userId, isEditMode, initialStaff = null }) => {
  return (
    <AuthWizardProvider>
      <WizardLayout
        variant={variant}
        validation={validation}
        progressBar={progressBar}
        userId={userId}
        isEditMode={isEditMode}
        initialStaff={initialStaff}
      />
    </AuthWizardProvider>
  );
};

Wizard.propTypes = {
  variant: PropTypes.oneOf(['pills']),
  validation: PropTypes.bool,
  progressBar: PropTypes.bool,
  userId: PropTypes.string,
  isEditMode: PropTypes.bool,
  initialStaff: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])])
};

export default Wizard;
